export default "__VITE_ASSET__DzN1pIJ___"